import { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { ajax } from 'jquery';
import './index.css';

function validateUsername(input: string): boolean {
    const pattern = /^[a-zA-Z][a-zA-Z0-9]{5,19}$/;
    return pattern.test(input);
}

function validatePassword(input: string): boolean {
    const regex = /^[a-zA-Z0-9]{6,20}$/;
    return regex.test(input);
}

const Login = () => {

    const usernameRef = useRef<HTMLInputElement>(null);
    const passwordRef = useRef<HTMLInputElement>(null);
    const password2Ref = useRef<HTMLInputElement>(null);

    useEffect(() => {
        
    }, [])

    const postData = async () => {
        const username = usernameRef.current!.value;
        const password = passwordRef.current!.value;
        try {
            const result = await ajax({
                method: "POST",
                contentType: 'application/json',
                url: '/api/v1/countryball_card/user/login',
                data: JSON.stringify({
                    username: username,
                    password: password
                })
            })
            window.location.href = '/weeknotes'
        } catch (err) {
            alert('用户名或密码错误！')
        }
    }

    return (
        <div className='page-wrap card-page myballs-page'>
            {
                <div className="login-page-content">
                    <h3 className="login-title">登录国家球日记账户</h3>
                    <div className="login-form">
                        <p className="input-title">用户名</p>
                        <input type="text" ref={usernameRef} placeholder='请输入用户名' />
                        <p className="input-title">密码</p>
                        <input type="password" ref={passwordRef} placeholder='请输入密码' />
                    </div>
                    <div className="add-new-ball-box">
                        <a href="#" onClick={postData} className="common-btn add-new-ball">登录</a>
                        <a href="/reg" className="common-link reg-link">还没有账户？点此注册</a>
                    </div>
                </div>
            }
        </div >
    );
}

export default Login